export default "__VITE_ASSET__B7P1Cm5J__"